import { useEffect, useState } from 'react';

// Posicionamiento compartido de modales anclados (ModalExportarPDF y
// ModalConfirmacion): centrado horizontal en el viewport, con el borde
// superior a la altura del botón disparador (anchorRect).
//
// - maxHeight se calcula contra el borde inferior real del viewport, así el
//   card nunca se corta: si el contenido no entra, scrollea .modal-body.
// - Recalcula en resize (window y visualViewport): si el viewport cambia con
//   el modal abierto (rotación, DevTools responsive), la posición se rehace.
// - ≤680px devuelve {} — el CSS mobile toma el control (bottom-sheet).
export default function useAnchoredModalStyle(anchorRect, { maxWidth = 520, minVisible = 280 } = {}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const onResize = () => setTick(t => t + 1);
    window.addEventListener('resize', onResize);
    window.visualViewport?.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.visualViewport?.removeEventListener('resize', onResize);
    };
  }, []);

  if (!anchorRect) return {};

  const vw = window.visualViewport?.width ?? window.innerWidth;
  const vh = window.visualViewport?.height ?? window.innerHeight;
  if (vw <= 680) return {};

  const MARGEN = 12;
  const width = Math.min(maxWidth, vw - 2 * MARGEN);

  // Debajo del botón; si abajo no quedan al menos minVisible px, sube lo justo
  // (puede taparlo, pero el modal queda entero y usable dentro del viewport).
  const top = Math.max(MARGEN, Math.min(anchorRect.bottom + 8, vh - MARGEN - minVisible));

  return {
    position: 'fixed',
    top,
    left: '50%',
    transform: 'translateX(-50%)',
    width,
    maxWidth: width,
    maxHeight: vh - top - MARGEN,
    margin: 0,
  };
}
